<template>
  <div>
    <el-table :data="auditList" height="calc(100vh - 360px)">
      <el-table-column prop="id" label="订单ID">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.id }}</span>
          <span v-else>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="时间">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{
            scope.row.createTime | moment
          }}</span>
          <span v-else>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" label="异常账号">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">异常</span>
          <span v-else>正常</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantId" label="商家ID">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{
            scope.row.merchantId
          }}</span>
          <span v-else>{{ scope.row.merchantId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantUserId" label="商家用户ID">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{
            scope.row.merchantUserId
          }}</span>
          <span v-else>{{ scope.row.merchantUserId }}</span>
        </template></el-table-column
      >
      <el-table-column prop="userId" label="用户ID">
        <template slot-scope="scope">
          <a
            class="account-link"
            @click="getUserDetail(scope.row.userId, null)"
          >
            {{ scope.row.userId }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="amount" label="数量"> </el-table-column>
      <el-table-column prop="price" label="价格"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{ scope.row.__status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-tooltip content="审核通过" v-if="scope.row.status === 2">
            <el-button
              type="success"
              @click="approveAudit(scope.row)"
              icon="el-icon-success"
              size="small"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip content="拒绝" v-if="scope.row.status === 2">
            <el-button
              type="danger"
              @click="rejectAudit(scope.row)"
              icon="el-icon-error"
              size="small"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="user-withdrawal-records-wrap">
      <el-dialog
        :visible.sync="showUserDialog"
        title="账户余额信息"
        width="1200px"
      >
        <withdraw-records
          v-if="showUserDialog"
          :uid="nowUserId"
        ></withdraw-records>
      </el-dialog>
    </div>
    <div class="pager-wrap" style="text-align: right; margin: 10px 0px">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
      >
      </pagination>
    </div>
    <div class="user-withdrawal-records-wrap">
      <el-dialog
        :visible.sync="showUserDialog"
        title="账户余额信息"
        width="1200px"
      >
        <records
          v-if="showUserDialog"
          :uid="nowUserId"
          :emails="emails"
        ></records>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Records from '../records'
import Pagination from 'components/pagination'
import WithdrawRecords from '../records'

export default {
  name: 'AuditList',
  data() {
    return {
      showUserDialog: false,
      nowUserId: '',
      emails: '',
    }
  },
  computed: {
    ...mapState('merchantAudit', ['auditList', 'audistCount', 'pagination']),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('merchantAudit', ['approve', 'reject']),
    showPrompt(content, callback) {
      return this.$confirm(content, '提示', {
        type: 'warning',
      }).then(() => {
        return callback()
          .then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
          })
          .finally(() => {
            this.refreshList()
          })
      })
    },
    approveAudit(audit) {
      this.showPrompt('确认通过审核吗？', () => this.approve({ id: audit.id }))
    },
    rejectAudit(audit) {
      this.showPrompt('确认拒绝通过吗？', () => this.reject({ id: audit.id }))
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1,
      })
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination)
    },
    getUserDetail(uid, email) {
      this.nowUserId = uid
      this.emails = email
      this.showUserDialog = true
    },
  },
  components: {
    Pagination,
    Records,
  },
}
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.account-link,
.network-link {
  color: @color-primary;
  &:hover {
    text-decoration: underline;
  }
}
.red {
  color: red;
  font-weight: bold;
}
</style>
